// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/name.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../Images/email-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../Images/lock-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../Svgs/collapse.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../Svgs/collapse-2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../Images/generate.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../Svgs/trash.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../Svgs/arrow-narrow-right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../Svgs/generate-text.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../Svgs/generate-image.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../Svgs/generate-code.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../Svgs/generate-video.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../Svgs/generate-voice.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../Svgs/text-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../Svgs/image-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../Svgs/image-check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../Svgs/plus-circle.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../Svgs/download.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../Images/user-normal.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../Images/location.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../Images/user-check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../Images/setinha.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `pre,
code {
  white-space: pre-wrap;
}

body .btn.btn-primary {
  font-size: 14px;
  font-weight: 600;
  border-radius: 12px;
}

body .btn.btn-dark {
  font-size: 14px;
  font-weight: 600;
  border-radius: 12px;
}

body .btn.btn-light {
  font-size: 14px;
  font-weight: 600;
  border-radius: 12px;
}

body .add-list-btn {
  padding: 8px 26px;
}

body .cancel-btn {
  padding: 8px 26px;
}

::selection {
  background-color: #0084ff !important;
  color: #fff !important;
}

body {
  background-color: #f3f5f7;
  margin: 0 !important;
  padding: 0 !important;
  font-family: "Inter", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #151718;
  overflow-x: hidden;
}
body .over-menu {
  overflow: inherit;
}

.content {
  width: 100%;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

.orders.row.no-padding > div {
  padding-left: 0 !important;
}

#root > div > nav > div > div > a {
  color: #fff;
}

.menus {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  list-style: none;
}

.menu-items {
  position: relative;
  font-size: 14px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.menu-items a {
  display: block;
  font-size: inherit;
  color: inherit;
  text-decoration: none;
}

.menu-items button {
  display: flex;
  align-items: center;
  color: inherit;
  font-size: inherit;
  border: none;
  background-color: transparent;
  cursor: pointer;
}

button span {
  margin-left: 3px;
}

.menu-items > a,
.menu-items button {
  text-align: left;
  padding: 0.7rem 1rem;
}

.arrow::after {
  content: "";
  display: inline-block;
  margin-left: 0.28em;
  vertical-align: 0.09em;
  border-top: 0.42em solid;
  border-right: 0.32em solid transparent;
  border-left: 0.32em solid transparent;
}

.dropdown {
  position: absolute;
  right: 0;
  left: auto;
  font-size: 0.875rem;
  padding: 0.5rem 0;
  list-style: none;
  display: none;
  min-width: 100px;
  border-radius: 0.2rem;
}

.dropdown-submenu {
  position: absolute;
  right: 0;
  left: auto;
  box-shadow: 0 10px 15px -3px rgba(46, 41, 51, 0.08), 0 4px 6px -2px rgba(71, 63, 79, 0.16);
  font-size: 0.875rem;
  padding: 0.5rem 0;
  list-style: none;
}

.dropdown.show {
  display: flex;
  position: absolute;
  justify-content: flex-end;
  z-index: auto;
}

.dropdown.child {
  min-width: 10rem;
}

.dropdown .dropdown-submenu {
  background-color: #5c84bf;
  color: #fff;
  display: none;
}

.dropdown .dropdown-submenu.show {
  display: block;
  z-index: 2;
}

.aaa {
  overflow: inherit;
}

.pagination-table > div:nth-child(2) {
  overflow: inherit;
}

.containerLoginImage {
  background: #141718;
  min-height: 100vh;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  color: #fff;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  align-content: center;
}

.containerLoginImage h2 {
  font-size: 48px;
  font-weight: 700;
  letter-spacing: -1px;
  width: 90%;
  margin-bottom: 50px;
}

.containerLoginImage h4 {
  font-size: 24px;
  color: #e8ecef;
  font-weight: 400;
}

.left-image-login {
  width: 100%;
  height: 330px;
  margin-top: 60px;
}

.containerLoginForm {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}

.containerLoginForm .form-login {
  width: 400px;
  margin-top: 40px;
}

.form-login label {
  display: none;
}

.form-login .name-input {
  background: #F3F5F7 url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 16px center;
  padding: 14px 38px;
  color: #181a20;
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-radius: 12px;
}
.form-login .name-input::placeholder {
  color: #B1B3B6;
}

.form-login .email-input {
  background: #F3F5F7 url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat 14px center;
  padding: 14px 40px;
  color: #181a20;
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-radius: 12px;
}
.form-login .email-input::placeholder {
  color: #B1B3B6;
}

.form-login .password-input {
  background: #F3F5F7 url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat 16px center;
  padding: 14px 38px;
  color: #181a20;
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-radius: 12px;
}
.form-login .password-input::placeholder {
  color: #B1B3B6;
}

.form-login button {
  height: auto !important;
  max-width: inherit !important;
  padding: 12px 20px;
  font-size: 14px;
}

.forgot-pass-link {
  margin-bottom: 20px;
}

.forgot-pass-link a {
  font-size: 12px;
  font-weight: 400;
}

.login-body {
  padding: 20px;
}

.loginForm {
  max-width: 608px;
  padding: 5vh;
  border-radius: 10px;
}

.cs-login-form {
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: row;
}

.loginForm > h2 {
  font-style: normal;
  font-weight: 700;
  line-height: 110%;
  display: flex;
  align-items: center;
  color: #ffffff;
  margin-bottom: 3rem;
}

input.loginInput,
input.loginInput:focus {
  padding: 0px 20px;
  height: 56px;
  color: #9e9e9e;
  background-color: #181a20;
  border-radius: 12px;
}

input.passwordInput {
  margin-bottom: 3rem;
}

.submitLogin,
.submitLogin:hover {
  min-width: 200px;
  max-width: 380px;
  height: 42px;
  background: #0084ff;
  border-radius: 1rem;
  font-weight: 700;
  letter-spacing: 0.2px;
  color: #ffffff;
  margin-bottom: 1rem;
}

.submitLogin:hover {
  background: #004cff;
}

.loginAlignCenter {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.signUpText {
  font-size: 14px;
  color: #f5f5f5;
}

.signUpLink {
  font-weight: 600;
  color: #0084ff;
  text-decoration: none;
}

.signUpLink:hover {
  color: #004cff;
  cursor: pointer;
}

.form-group input::-webkit-selection,
.form-group textarea::-webkit-selection {
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
}
.form-group input::selection,
.form-group textarea::selection {
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
}

.buttonmod,
.buttonmod:hover {
  background-color: #22bb9c;
  border-radius: 50px;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0.2px;
  color: #ffffff;
  margin-bottom: 1rem;
}
.buttonmod .buttonmod:hover,
.buttonmod:hover .buttonmod:hover {
  background-color: rgba(34, 187, 156, 0.5882352941);
}

.row .form-group {
  margin-bottom: 15px;
}
.row .form-group label {
  margin-left: 5px;
  margin-bottom: 5px;
}

input[type=tel] {
  height: 56px;
  width: 100%;
  background-color: #181a20;
  border: none;
  color: #757575;
  padding: 6px 12px;
}

.product-image {
  background-size: contain !important;
  background-repeat: no-repeat !important;
}

body .custom-container {
  width: 100%;
  max-width: 100%;
  align-items: flex-start;
  justify-content: space-around;
  margin: 0;
  padding: 20px;
  background-color: #151718;
}

.login-container {
  width: 100%;
  display: flex;
  height: 95vh;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
}

.main-header {
  border-bottom: solid 1px #35383f;
  padding-bottom: 1px;
  margin-left: -40px;
  padding-left: 40px;
  margin-bottom: 40px;
}

.main-content {
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  flex-wrap: nowrap;
  align-content: flex-start;
  justify-content: flex-start;
  align-items: flex-start;
}

body .toggle-logo {
  margin-bottom: 40px;
  margin-top: 20px;
}

body .toggle-logo {
  display: flex;
  flex-flow: row-reverse;
  width: 100%;
  align-content: center;
  align-items: center;
  justify-content: flex-end;
}

body .toggle-logo span:first-of-type {
  display: block;
  width: 50px !important;
  height: 50px !important;
  transform: rotate(0deg) !important;
}

body .toggle-logo span:nth-of-type(n + 2) {
  display: none;
}

body .open-nav span:first-of-type {
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
}

body .closed-nav span:first-of-type {
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-position: center;
}

body .toggle-logo img {
  display: flex;
  width: 65%;
  margin-left: 20px;
}

body .react-datepicker {
  border: solid 1px #1f222a;
}

html body .react-datepicker__day--selected {
  background-color: #37bb9c;
}

body .react-datepicker__day--in-selecting-range,
body .react-datepicker__day--in-range {
  background-color: #1f222a;
}

body .react-datepicker__header {
  background-color: #37bb9c;
}

body .react-datepicker__navigation-icon::before,
body .react-datepicker__navigation:hover *::before {
  border-color: #1f222a;
  margin-top: 8px;
}

body .react-datepicker__day--in-selecting-range:hover,
body .react-datepicker__day--in-range:hover {
  background-color: #37bb9c;
}

body .bg-success-mod {
  background-color: #37bb9c;
}

body .rectangle {
  font-weight: 700;
}

body .form-group label,
.mod-label,
.label {
  font-size: 14px;
  font-weight: 600;
  color: #181a20;
}

body .PhoneInputInput {
  border-radius: 5px;
}
body .PhoneInputInput:focus {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(55, 187, 156, 0.4);
}

body .mod-color-picker {
  display: flex;
  flex-direction: column;
  align-items: center;
}

body .md-green-button {
  background-color: #37bb9c;
  border: none;
  border-radius: 20px;
  font-size: 12px;
  padding: 5px 20px;
  font-weight: 600;
}

body .md-green-button:hover,
body .md-green-button:focus-visible {
  background-color: #1a715d;
}

body .sidenav---navtext---1AE_f {
  color: #b3b7b9 !important;
  font-weight: 700;
  align-items: center;
}

body .sidenav---sidenav-nav---3tvij {
  max-height: 70vh;
  height: calc(100% - 350px);
  overflow-y: scroll;
}

body .left-menu .sidenav---selected---1EK3y {
  background: linear-gradient(270deg, #323337 50%, rgba(70, 79, 111, 0.5) 100%);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1), inset 0px 1px 0px rgba(255, 255, 255, 0.05);
  margin: 0 15px;
  border-radius: 10px;
}

body .sidenav---sidenav-nav---3tvij > .sidenav---sidenav-navitem---uwIJ- {
  margin: 0 15px;
  border-radius: 10px;
  height: 44px;
  margin-bottom: 10px;
}

html body .sidenav---sidenav-nav---3tvij > .sidenav---sidenav-navitem---uwIJ-:hover {
  display: flex;
  background-color: #323337 !important;
  align-items: center;
}

body .sidenav---sidenav-nav---3tvij > .sidenav---sidenav-navitem---uwIJ- > .sidenav---navitem---9uL5T {
  border-radius: 10px !important;
  display: flex;
  background-color: transparent;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  gap: 15px;
  align-items: center;
  padding-left: 12px;
}

body .left-menu .sidenav---selected---1EK3y .sidenav---navitem---9uL5T {
  height: 44px;
  line-height: 44px !important;
}

.sidenav---sidenav-navitem---uwIJ-:hover,
.sidenav---navitem---9uL5T:hover,
body .sidenav---sidenav-nav---3tvij > .sidenav---sidenav-navitem---uwIJ- > .sidenav---navitem---9uL5T:hover {
  background-color: transparent !important;
  box-shadow: none !important;
}

body .sidenav---sidenav-nav---3tvij > .sidenav---sidenav-navitem---uwIJ- > .sidenav---navitem---9uL5T .sidenav---navicon---3gCRo {
  height: 46px;
  line-height: 44px;
  width: 34px;
}

body .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL {
  min-width: 300px;
}

body .left-menu .sidenav---selected---1EK3y .sidenav---navtext---1AE_f {
  color: #fff !important;
  font-weight: 700;
}

body .form-control:focus {
  box-shadow: 0 0 0 0.25rem rgba(55, 187, 156, 0.4);
}

.chat-header {
  background: #fefefe;
  border-bottom: 1px solid #e8ecef;
  box-shadow: 0px 12px 28px -12px rgba(0, 0, 0, 0.1);
  padding: 20px 20px;
}

.chat-header h4 {
  margin-bottom: 0;
  color: #141718;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -1px;
}

.conversation-block {
  padding: 0 0 0 12px;
  box-shadow: 0px 24px 60px rgba(0, 0, 0, 0.1);
  border-right: 1px solid #e8ecef;
}

.conversation-block .container {
  padding: 40px;
}

.conversation-block .prompt-box {
  padding: 0 30px 10px 30px;
}

.history-block {
  margin-left: 0 !important;
  background-color: #f7f7f7;
  padding-left: 0px;
}

.history-block .container {
  padding: 0px 30px 10px 30px;
}

.new-chat-block {
  height: 100px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center;
  padding-right: 30px;
  padding-left: 30px;
}

.new-chat-block button {
  width: 100%;
}

.history-block .conversation-list-item .chat-content {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0;
  padding-right: 1em;
  font-size: 14px;
  color: #6c7275;
}

.history-block .conversation-list-item .chat-content::after {
  content: "...";
  position: absolute;
  bottom: 0;
  right: 0;
  padding-left: 0.5em;
  background: linear-gradient(to right, rgba(255, 255, 255, 0), white 50%);
}

.meta-chat-info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
  margin-top: 10px;
}

.meta-chat-info .user-photo img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.meta-chat-info .generate-time {
  font-size: 12px;
  color: #6c7275;
}

.robot-avatar {
  background-color: #2d84ff;
  background-size: 80% !important;
  background-repeat: no-repeat;
}

.thinking-dots-loader {
  width: 42px;
  height: 15px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.dots {
  width: 9.6px;
  height: 9.6px;
  background: #141718;
  color: #141718;
  border-radius: 50%;
  box-shadow: 16px 0, -16px 0;
  animation: dots-u8fzftsm 1s infinite linear alternate;
}

@keyframes dots-u8fzftsm {
  0% {
    box-shadow: 16px 0, -16px 0;
  }
  33% {
    box-shadow: 16px 0, -16px 0 rgba(20, 23, 24, 0.13);
    background: rgba(20, 23, 24, 0.13);
  }
  66% {
    box-shadow: 16px 0 rgba(20, 23, 24, 0.13), -16px 0;
    background: rgba(20, 23, 24, 0.13);
  }
}
.prompt-data {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
  height: 40px;
  justify-content: flex-start;
  gap: 20px;
}

.prompt-data small {
  font-size: 12px;
  color: #b4b9ba;
}

.robot-meta-info {
  font-size: 12px;
  color: #b4b9ba;
  font-weight: 500;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  align-items: center;
  padding-top: 4px;
  padding-left: 12px;
  min-width: 750px;
  width: fit-content;
}

.user-meta-info {
  font-size: 12px;
  color: #b4b9ba;
  font-weight: 500;
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-right: 20px;
}

.prompt-data .thinking-dots-loader {
  margin-bottom: 0;
}

.tab-content {
  display: flex;
  flex-direction: row;
  gap: 0px;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
  justify-content: center;
}

.googlesignin {
  width: 100% !important;
  border: solid 2px #E7ECEE !important;
  display: flex !important;
  justify-content: center;
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: none !important;
}

.login-options {
  margin: 50px 0;
  background-color: #F3F5F7;
  border-radius: 12px;
  padding: 6px;
}
.login-options .btn-default {
  width: 190px;
  height: 40px;
  border-radius: 8px;
  padding: 8px 24px 8px 24px;
  border: none;
  color: #6C7275;
  font-weight: 500;
  font-size: 14px;
}
.login-options .btn-default.active {
  border: none;
  gap: 8px;
  background-color: #fff;
  color: #232627;
  border-radius: 8px;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.07), 0px 4px 2px 0px #FFF inset;
}

body .nav-tabs .nav-link {
  border: none;
  background-color: #f3f5f7;
  margin-bottom: 12px;
  min-height: 44px;
  border-radius: 10px;
  font-weight: 700;
  padding-left: 20px;
  padding-right: 20px;
  margin-right: 14px;
}

body .nav-tabs .nav-link .trait-button {
  font-size: 12px;
  font-weight: 600;
}

body .nav-tabs .nav-link.active {
  background-color: #000;
}

body .nav-tabs .nav-link .icon-tab-img svg path {
  stroke: #7C8285;
}

body .nav-tabs .nav-link.active .icon-tab-img path {
  stroke: #fff;
}

body .nav-tabs .nav-link .icon-tab-txt svg {
  stroke: #7C8285;
}

body .nav-tabs .nav-link.active .icon-tab-txt svg {
  stroke: #fff;
}

body .nav-tabs .nav-link .button-text {
  color: #7C8285;
  font-size: 14px;
  font-weight: 600;
  padding-left: 10px;
}

body .nav-tabs .nav-link.active .button-text {
  color: #fff;
}

body .nav-tabs {
  border-bottom: none;
}

body .nav-tabs .nav-link:hover {
  margin-bottom: -1px;
}

.prompt-box .form-group label {
  display: none;
}

.prompt-box textarea {
  border-radius: 10px;
  min-height: 42px;
  resize: none;
  font-size: 14px;
  padding: 10px 15px;
  font-weight: 500;
}

.prompt-box textarea::placeholder {
  color: #B6B8B9;
}

body .form-control:focus {
  box-shadow: 0 1px 2px 1px rgba(142, 142, 142, 0.3);
}

.generate-button {
  background: #0084ff url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat;
  background-position: 95px center;
  padding: 8px 50px 9px 20px !important;
  border-radius: 10px !important;
  margin-bottom: 18px;
  font-size: 16px;
  font-weight: 600;
}

.prompt-box-inner {
  display: flex;
  align-items: end;
  gap: 10px;
}

.prompt-box-inner .prompt-box-input {
  width: 100%;
}

.new-chat-button {
  background-position: center;
  padding: 7px 20px 7px 20px !important;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: center;
  gap: 10px;
  max-width: 250px;
  border: solid 2px #0084ff;
  background-color: transparent;
  color: #0084ff;
}

.new-chat-button svg {
  stroke: #0084ff !important;
}

.new-chat-button:hover svg {
  stroke: #fff !important;
}

.chat-history-header {
  padding-top: 20px;
}

.chat-history-header .profile {
  background: #fff;
  border-bottom: 1px solid #e8ecef;
  padding: 15px 20px 14px 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: space-around;
  gap: 10px;
}

.chat-history-header .profile button {
  background-color: #181a20;
  border: none;
  font-weight: 600;
  color: #fff;
  font-size: 16px;
  border-radius: 12px;
}

.chat-history-header .profile .top-profile {
  position: relative;
  width: 50px;
  height: 40px;
}

.chat-history-header .profile .top-profile img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.chat-history-header .profile .top-profile .active-user {
  background-color: #22bb9c;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  position: absolute;
  bottom: 0px;
  right: 10px;
  border: solid 3px #fff;
}

.chat-history-header .sub-header {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  align-items: center;
  padding: 10px 30px;
  color: #919597;
}

.chat-history-header .sub-header button {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
  background-color: transparent;
  height: 26px;
  width: 26px;
  border: none;
}

.chat-history-header .sub-header .counter {
  background-color: #e8ecef;
  border-radius: 6px;
  font-size: 12px;
  padding: 4px 8px;
  color: #6c7275;
  font-weight: 500;
}

.chat-history-header .sub-header > div {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: center;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
}

.chat-history-header .sub-header > div h6 {
  margin-bottom: 0;
}

.custom-content {
  height: 95vh;
  display: flex;
  flex-direction: column;
}

.header-home {
  text-align: center;
  margin-top: 100px;
  margin-bottom: 50px;
}

.header-home h1 {
  font-size: 42px;
  font-weight: 700;
}

.header-home p {
  color: #6c7275;
  font-size: 22px;
}

.content-left {
  width: 60px;
  height: 60px;
  text-indent: -99999999px;
  overflow: hidden;
}

.content-right {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat;
  text-indent: -99999999px;
  overflow: hidden;
  width: 30px;
  height: 30px;
}

.generate-text {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat;
}

.generate-img {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat;
}

.generate-code {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat;
}

.generate-video {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat;
}

.generate-voice {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat;
}

.type-text {
  background: #e8ecef url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat;
  background-position: right 10px center;
  padding: 4px 30px 4px 15px;
  color: #232627;
  border-radius: 6px;
  font-weight: 700;
  font-size: 12px;
}

.type-image {
  background: #e8ecef url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat;
  background-position: right 10px center;
  padding: 4px 30px 4px 15px;
  color: #232627;
  border-radius: 6px;
  font-weight: 700;
  font-size: 12px;
}

.variation-btn {
  background: #141718 url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat;
  background-position: right 10px center;
  padding: 10px 38px 10px 15px;
  color: #fff;
  font-weight: 700;
  font-size: 12px;
  border: none;
  border-radius: 10px;
}

.upscale-btn {
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_16___}) no-repeat;
  background-position: right 10px center;
  padding: 10px 38px 10px 15px;
  color: #141718;
  font-weight: 700;
  font-size: 12px;
  border: none;
  border-radius: 10px;
}

.variation-btn:hover {
  background-color: #141718;
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.4);
}

.upscale-btn:hover,
.upscale-btn.btn-check:checked + .btn,
.upscale-btn.btn.active,
.upscale-btn.btn.show,
.upscale-btn.btn:first-child:active,
:not(.btn-check) + .upscale-btn.btn:active {
  background-color: #ffffff !important;
  color: #141718 !important;
  transform: translateY(-2px);
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.4);
}

.download-btn {
  background: #141718 url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat;
  background-position: right 10px center;
  padding: 10px 38px 10px 15px;
  color: #fff;
  font-weight: 700;
  font-size: 12px;
  border: none;
  border-radius: 10px;
}

.download-btn:hover {
  background-color: #141718;
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.4);
}

.image-actions {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-content: flex-end;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-end;
  position: absolute;
}

.full-image {
  width: 720px;
  height: 720px;
  overflow: hidden;
  border-radius: 20px;
}

.conversation-item .blur-bg {
  display: none;
}

.image-variate-container .blur-bg {
  display: flex;
}

.image-variate-container .full-image .blur-bg {
  display: flex;
}

.full-image .blur-bg {
  position: relative;
  width: 100%;
  height: 58px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-end;
  padding-bottom: 10px;
  align-items: center;
  transition: bottom 0.3s ease;
  bottom: -300px;
  border-bottom-left-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
}

.blur-bg {
  position: relative;
  width: 100%;
  height: 58px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-end;
  padding-bottom: 10px;
  align-items: center;
  transition: bottom 0.3s ease;
  bottom: -100px;
}

.quadrant:hover .blur-bg {
  bottom: 0;
}

.full-image:hover .blur-bg {
  bottom: 58px;
  border-bottom-left-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
}

.blur-bg::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(10px);
  border-bottom-left-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
}

.default-response.bot-chat {
  min-width: 1px;
  width: 100%;
}

.default-response.bot-chat .image-complete .full-image {
  position: relative;
}

.default-response.bot-chat .image-complete .full-image .blur-bg {
  bottom: -110px;
  position: absolute;
}

.default-response.bot-chat .image-complete .full-image:hover .blur-bg {
  bottom: 0;
}

.default-response.me-chat {
  min-width: 1px;
  width: 100%;
}

.ai-image {
  max-height: 720px;
  width: 720px;
  height: 720px;
}

.profile-input-option.name-input {
  border-radius: 12px;
  padding: 14px 16px 14px 46px;
  background: #F3F5F7 url(${___CSS_LOADER_URL_REPLACEMENT_18___}) no-repeat 16px center;
  font-size: 14px;
  font-style: normal;
  color: #141718;
}

.profile-input-option.email-input {
  padding: 14px 16px 14px 46px;
  background: #F3F5F7 url(${___CSS_LOADER_URL_REPLACEMENT_18___}) no-repeat 16px center;
  font-size: 14px;
  font-style: normal;
  color: #141718;
}

.profile-input-option.location-input {
  padding: 14px 16px 14px 46px;
  background: #F3F5F7 url(${___CSS_LOADER_URL_REPLACEMENT_19___}) no-repeat 16px center;
  font-size: 14px;
  font-style: normal;
  color: #141718;
}

.profile-input-option.bio-input {
  padding: 14px 16px 14px 46px;
  background: #F3F5F7 url(${___CSS_LOADER_URL_REPLACEMENT_20___}) no-repeat 16px 16px;
  font-size: 14px;
  font-style: normal;
  color: #141718;
}

.big-save-button {
  width: 100%;
  text-align: left;
  padding: 10px 20px 10px 20px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 12px;
  text-align: center;
}

.add-button {
  padding: 10px 20px 10px 20px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 12px;
}

.big-delete-btn {
  background-color: #D84C10 !important;
  border: none !important;
  padding: 10px 20px;
  font-weight: 600;
  width: 100%;
}

.delete-account-tab h2,
.edit-profile h2,
.password-tab h2,
.members-tab h2,
.applications-tab h2 {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 0;
}

.members-tab {
  overflow-y: auto;
}

body .delete-account-tab p {
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  color: #6C7275;
  padding-left: 0px !important;
  margin-top: 20px;
}

body .delete-account-tab small.dark {
  color: #141718;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
}

.configuration-content {
  min-height: 500px;
}

.hootsuite-button {
  background-color: #141718;
  color: #fff;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 8px;
  margin-top: 4px;
  cursor: pointer;
}

.post-preview {
  background-color: #fff;
  border-radius: 12px !important;
  padding: 20px;
}

.message-upload {
  margin-bottom: 20px;
}

.message-upload h5 {
  color: #232627;
  font-size: 15px;
  margin-bottom: 0;
}

body .upload-components .custom-file-upload > .img-wrap {
  background-image: none;
}

.message-upload small {
  font-size: 12px;
  color: #909597;
}

.upload-components {
  display: flex;
  flex-direction: row;
}

.divider-login {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  gap: 24px;
  margin-top: 30px;
}

.line-login {
  height: 1px;
  background-color: #B6B8B9;
  width: 160px;
}

.divider-login h5 {
  color: #B6B8B9;
  font-size: 12px;
  margin-bottom: 0;
}

.chat-counter {
  padding: 12px;
  background-color: #242627;
  height: 14px !important;
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  margin-right: 16px;
  border-radius: 8px;
  color: #6C7274 !important;
}

.custom-checkbox input[type=checkbox] {
  display: none;
}

.custom-checkbox span {
  position: relative;
  display: block;
  width: 20px;
  height: 20px;
  border: 2px solid #B6B8B9;
  border-radius: 4px;
}

.custom-checkbox input[type=checkbox]:checked + span:after {
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  background: #2D84FF;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 3px;
}

.robot-saying {
  flex-direction: row;
  display: flex;
  gap: 20px;
}

.form-login .action-title {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-start;
  margin-bottom: 20px;
}

.form-login .action-title img {
  cursor: pointer;
}

.form-login h5 {
  font-weight: 600;
  color: #141718;
  letter-spacing: -0.5px;
  margin-bottom: 0px;
}

.login-link {
  font-size: 12px;
  color: #6C7275;
  font-weight: 400;
}

.login-link a {
  color: #343839;
  text-decoration: none;
}

.denied-content p {
  margin: 0;
}

.denied-content p a {
  color: #141718;
  margin-top: 10px;
  display: flex;
  align-content: center;
  align-items: center;
}

.denied-content p a::after {
  content: "";
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 5px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) no-repeat center center;
  background-size: contain;
}

.html {
  display: block;
  background-color: #131718;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 20px;
}

.html p {
  margin: 0;
  color: #f3f5f7;
}

.login-button-container {
  width: 430px;
}

.curvy-textarea textarea {
  border-radius: 20px !important;
  border: 1px solid #444;
  background-color: rgba(41, 40, 40, 0.0352941176);
  color: #ddd;
  padding: 12px 15px;
  outline: none;
  transition: all 0.3s ease-in-out;
}
.curvy-textarea textarea:focus {
  border-color: #818181;
  box-shadow: 0 0 7px #818181;
  background-color: #222;
  color: #ddd;
}
.curvy-textarea textarea::placeholder {
  color: #888;
  opacity: 0.7;
}

.chat-container {
  overflow-y: auto;
  max-height: 100vh;
}
.chat-container::-webkit-scrollbar {
  width: 2px;
  background: transparent;
}
.chat-container::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 10px;
}
.chat-container:hover::-webkit-scrollbar {
  width: 4px;
}
.chat-container:hover::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
}

/* RESPONSIVE */
@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  body .robot-meta-info {
    min-width: 746px;
  }
  body .prompt-box {
    margin-left: 10px;
    margin-right: 20px;
  }
  body .prompt-box textarea {
    width: 96%;
  }
  body .blur-bg {
    height: 60px;
  }
}
@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
  body .image-variate-container {
    position: relative;
    width: 490px;
    height: 490px;
  }
  body .default-response.bot-chat {
    min-width: 530px;
  }
  body .quadrant {
    width: 245px;
    height: 245px;
  }
  body .full-image {
    width: 490px;
    height: 490px;
  }
  body .full-image > div {
    width: 490px;
    height: 490px;
  }
  body .default-response.me-chat {
    min-width: 530px;
  }
  body .user-meta-info {
    min-width: 494px;
  }
  body .robot-meta-info {
    min-width: 530px;
  }
  body .prompt-box {
    width: 566px;
    margin-left: 10px;
  }
  body .prompt-box textarea {
    width: 90%;
  }
  body .blur-bg {
    height: 70px;
  }
  body .image-actions {
    width: 90%;
  }
  body .variation-btn {
    font-size: 11px;
    line-height: 13px;
    text-align: left;
  }
  body .upscale-btn {
    font-size: 11px;
    line-height: 13px;
    text-align: left;
  }
}
/* MOBILE LOGIN */
/* Mobile devices (portrait) */
@media only screen and (max-width: 480px) {
  .containerLoginImage {
    align-items: center;
    display: none;
  }
  .containerLoginImage h2 {
    font-size: 48px;
    font-weight: 700;
    letter-spacing: -1px;
    width: 90%;
    margin-bottom: 50px;
    text-align: center;
    line-height: 44px;
  }
  .containerLoginImage h4 {
    font-size: 20px;
    color: #e8ecef;
    font-weight: 400;
    text-align: center;
    width: 90%;
  }
  .login-container {
    padding-top: 40px;
    justify-content: flex-start;
    height: 100%;
  }
  .login-body {
    padding: 0;
  }
  .login-options {
    width: 85%;
    margin: 20px auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .login-button-container {
    max-width: 82%;
    margin: 0 auto;
  }
  .transition-container {
    transition: margin-top 0.5s ease-in-out, transform 0.5s ease-in-out;
  }
  .transition-container.moved-down {
    margin-top: auto;
  }
  .logo img {
    transform: scale(1.5); /* Increase the size without affecting layout */
  }
  .login-body .main-content {
    width: 90%;
    margin: 0 auto;
    margin-bottom: 30px;
  }
  .login-body .main-content.reset {
    width: 100%;
  }
  .form-login .action-title {
    justify-content: center;
  }
  .containerLoginForm .form-login {
    width: 340px;
    margin-bottom: 20px;
  }
  .plan-container .plan-option {
    margin: 10px;
    border-radius: 20px;
  }
  .plan-container .plan-option.best-option {
    margin: 10px;
  }
  .features-list > div {
    width: 90%;
  }
  .container .payment-info .stripe-container {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  body .payment-info .plan-discriminator {
    padding-top: 40px;
  }
  body .payment-info .periodicity-opt {
    flex-direction: column;
  }
  body .payment-info .stripe-elements {
    width: 90%;
    margin-top: 40px;
  }
  body .periodicity-container {
    width: 100%;
  }
  body .industry-container .title-container {
    width: 80%;
  }
  body .centered-industry-items .input-container {
    width: 300px;
  }
  body .centered-industry-items .input-container .css-1fdsijx-ValueContainer {
    width: 220px;
  }
  body .industry-container .btn-save-industry button {
    width: 300px;
  }
}
.button-wrapper {
  margin-top: 10px;
  margin-left: 10px;
  position: absolute;
  top: 8px;
  left: 24px;
}

.back-button {
  font-size: 16px;
  padding: 4px 8px;
  border: 1px solid black;
  background-color: white;
  border-radius: 4px;
}

.custom-hover:hover {
  background-color: #0d6efd !important; /* override Bootstrap's bg-dark */
  color: white !important; /* ensure text stays visible */
  border-color: #0d6efd !important;
  transition: background-color 0.2s ease;
}

/* Mobile devices (landscape) */`, "",{"version":3,"sources":["webpack://./src/Assets/Css/index.scss"],"names":[],"mappings":"AAEA;;EAEE,qBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAAF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,oCAAA;EACA,sBAAA;AADF;;AAIA;EAKE,yBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,gCAAA;EAEA,mCAAA;EACA,kCAAA;EACA,yBAAA;EACA,kBAAA;AAPF;AANE;EACE,iBAAA;AAQJ;;AAOA;EACE,WAAA;AAJF;;AAOA;EACE,+EAAA;AAJF;;AAOA;EACE,0BAAA;AAJF;;AAOA;EACE,WAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;AAJF;;AAOA;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;;EAEE,gBAAA;EACA,oBAAA;AAJF;;AAOA;EACE,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,wBAAA;EACA,sCAAA;EACA,qCAAA;AAJF;;AAOA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,0FAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,yBAAA;EACA,WAAA;EACA,aAAA;AAJF;;AAOA;EACE,cAAA;EACA,UAAA;AAJF;;AAOA;EACE,iBAAA;AAJF;;AAOA;EACE,iBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAJF;;AAOA;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,UAAA;EACA,mBAAA;AAJF;;AAOA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAJF;;AAOA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AAJF;;AAOA;EACE,YAAA;EACA,gBAAA;AAJF;;AAOA;EACE,aAAA;AAJF;;AAOA;EACE,iFAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AAJF;AAME;EACE,cAAA;AAJJ;;AAQA;EACE,iFAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AALF;AAOE;EACE,cAAA;AALJ;;AAUA;EACE,iFAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AAPF;AASE;EACE,cAAA;AAPJ;;AAWA;EACE,uBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;AARF;;AAWA;EACE,mBAAA;AARF;;AAWA;EACE,eAAA;EACA,gBAAA;AARF;;AAWA;EACE,aAAA;AARF;;AAWA;EACE,gBAAA;EACA,YAAA;EACA,mBAAA;AARF;;AAWA;EACE,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AARF;;AAWA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AARF;;AAWA;;EAEE,iBAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;AARF;;AAWA;EACE,mBAAA;AARF;;AAWA;;EAEE,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;AARF;;AAWA;EACE,mBAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;AARF;;AAWA;EACE,eAAA;EACA,cAAA;AARF;;AAWA;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AARF;;AAWA;EACE,cAAA;EACA,eAAA;AARF;;AAeI;;EACE,WAAA;EACA,qCAAA;AAXN;AAmBI;;EACE,WAAA;EACA,qCAAA;AAXN;;AAgBA;;EAEE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;AAbF;AAeE;;EACE,kDAAA;AAZJ;;AAiBE;EACE,mBAAA;AAdJ;AAgBI;EACE,gBAAA;EACA,kBAAA;AAdN;;AAmBA;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AAhBF;;AAmBA;EACE,mCAAA;EACA,uCAAA;AAhBF;;AAqBA;EACE,WAAA;EACA,eAAA;EACA,uBAAA;EACA,6BAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AAlBF;;AAqBA;EACE,gCAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AAlBF;;AAqBA;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,2BAAA;EACA,uBAAA;AAlBF;;AAqBA;EACE,mBAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;AAlBF;;AAqBA;EACE,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,kCAAA;AAlBF;;AAqBA;EACE,aAAA;AAlBF;;AAqBA;EACE,6BAAA;EACA,yDAAA;EACA,4BAAA;EACA,2BAAA;AAlBF;;AAqBA;EACE,6BAAA;EACA,yDAAA;EACA,4BAAA;EACA,2BAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,UAAA;EACA,iBAAA;AAlBF;;AAqBA;EACE,yBAAA;AAlBF;;AAqBA;EACE,yBAAA;AAlBF;;AAqBA;;EAEE,yBAAA;AAlBF;;AAqBA;EACE,yBAAA;AAlBF;;AAqBA;;EAEE,qBAAA;EACA,eAAA;AAlBF;;AAqBA;;EAEE,yBAAA;AAlBF;;AAqBA;EACE,yBAAA;AAlBF;;AAqBA;EACE,gBAAA;AAlBF;;AAqBA;;;EAGE,eAAA;EACA,gBAAA;EACA,cAAA;AAlBF;;AAqBA;EAME,kBAAA;AAvBF;AAkBE;EACE,UAAA;EACA,iDAAA;AAhBJ;;AAsBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAnBF;;AAsBA;EACE,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAnBF;;AAsBA;;EAEE,yBAAA;AAnBF;;AAsBA;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;AAnBF;;AAuBA;EACE,gBAAA;EACA,0BAAA;EACA,kBAAA;AApBF;;AAuBA;EACE,6EAAA;EACA,uFAAA;EACA,cAAA;EACA,mBAAA;AApBF;;AAuBA;EACE,cAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AApBF;;AAuBA;EACE,aAAA;EAEA,oCAAA;EACA,mBAAA;AArBF;;AAwBA;EACE,8BAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;AArBF;;AAyBA;EACE,YAAA;EACA,4BAAA;AAtBF;;AAyBA;;;EAGE,wCAAA;EACA,2BAAA;AAtBF;;AAyBA;EACE,YAAA;EACA,iBAAA;EACA,WAAA;AAtBF;;AAyBA;EACE,gBAAA;AAtBF;;AAyBA;EACE,sBAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,iDAAA;AAtBF;;AAyBA;EACE,mBAAA;EACA,gCAAA;EACA,kDAAA;EACA,kBAAA;AAtBF;;AAyBA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAtBF;;AAyBA;EACE,mBAAA;EACA,4CAAA;EACA,+BAAA;AAtBF;;AAyBA;EACE,aAAA;AAtBF;;AAyBA;EACE,yBAAA;AAtBF;;AAyBA;EACE,yBAAA;EACA,yBAAA;EACA,iBAAA;AAtBF;;AAyBA;EACE,2BAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAtBF;;AAyBA;EACE,WAAA;AAtBF;;AAyBA;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAtBF;;AAyBA;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,mBAAA;EACA,wEAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAtBF;;AAyBA;EACE,eAAA;EACA,cAAA;AAtBF;;AAyBA;EACE,yBAAA;EACA,+BAAA;EACA,4BAAA;AAtBF;;AAyBA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAtBF;;AAyBA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,2BAAA;EACA,qDAAA;AAtBF;;AAyBA;EACE;IACE,2BAAA;EAtBF;EAyBA;IACE,kDAAA;IACA,kCAAA;EAvBF;EA0BA;IACE,kDAAA;IACA,kCAAA;EAxBF;AACF;AA2BA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,2BAAA;EACA,SAAA;AAzBF;;AA4BA;EACE,eAAA;EACA,cAAA;AAzBF;;AA4BA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAzBF;;AA4BA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,2BAAA;EACA,iBAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;EAGA,WAAA;EACA,kBAAA;AA3BF;;AA8BA;EACE,gBAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;AA3BF;;AA8BA;EACE,sBAAA;EACA,oCAAA;EACA,wBAAA;EACA,uBAAA;EACA,8BAAA;EACA,gBAAA;EACA,2BAAA;AA3BF;;AA8BA;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;AA3BF;AA6BE;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AA3BJ;AA6BI;EACE,YAAA;EACA,QAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,2EAAA;AA3BN;;AAgCA;EACE,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AA7BF;;AAgCA;EACE,eAAA;EACA,gBAAA;AA7BF;;AAgCA;EACE,sBAAA;AA7BF;;AAgCA;EACE,eAAA;AA7BF;;AAgCA;EACE,YAAA;AA7BF;;AAgCA;EACE,eAAA;AA7BF;;AAgCA;EACE,YAAA;AA7BF;;AAgCA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA7BF;;AAgCA;EACE,WAAA;AA7BF;;AAgCA;EACE,mBAAA;AA7BF;;AAgCA;EACE,mBAAA;AA7BF;;AAgCA;EACE,aAAA;AA7BF;;AAgCA;EACE,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AA7BF;;AAgCA;EACE,cAAA;AA7BF;;AAgCA;EACE,kDAAA;AA7BF;;AAiCA;EACE,qEAAA;EACA,gCAAA;EACA,qCAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,gBAAA;EACA,SAAA;AA9BF;;AAiCA;EACE,WAAA;AA9BF;;AAiCA;EACE,2BAAA;EACA,qCAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,6BAAA;EACA,cAAA;AA9BF;;AAiCA;EACE,0BAAA;AA9BF;;AAiCA;EACE,uBAAA;AA9BF;;AAiCA;EACE,iBAAA;AA9BF;;AAiCA;EACE,gBAAA;EACA,gCAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,SAAA;AA9BF;;AAiCA;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AA9BF;;AAiCA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AA9BF;;AAiCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AA9BF;;AAiCA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AA9BF;;AAiCA;EACE,yDAAA;EACA,4BAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AA9BF;;AAiCA;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;AA9BF;;AAiCA;EACE,gBAAA;AA9BF;;AAiCA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AA9BF;;AAiCA;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;AA9BF;;AAiCA;EACE,eAAA;EACA,gBAAA;AA9BF;;AAiCA;EACE,cAAA;EACA,eAAA;AA9BF;;AAiCA;EACE,WAAA;EACA,YAAA;EACA,wBAAA;EACA,gBAAA;AA9BF;;AAiCA;EACE,6DAAA;EACA,wBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AA9BF;;AAiCA;EACE,6DAAA;AA9BF;;AAiCA;EACE,6DAAA;AA9BF;;AAiCA;EACE,8DAAA;AA9BF;;AAiCA;EACE,8DAAA;AA9BF;;AAiCA;EACE,8DAAA;AA9BF;;AAiCA;EACE,sEAAA;EACA,sCAAA;EACA,0BAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AA9BF;;AAiCA;EACE,sEAAA;EACA,sCAAA;EACA,0BAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AA9BF;;AAiCA;EACE,sEAAA;EACA,sCAAA;EACA,4BAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;AA9BF;;AAiCA;EACE,mEAAA;EACA,sCAAA;EACA,4BAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;AA9BF;;AAiCA;EACE,yBAAA;EACA,WAAA;EACA,2BAAA;EACA,6CAAA;AA9BF;;AAiCA;;;;;;EAME,oCAAA;EACA,yBAAA;EACA,2BAAA;EACA,6CAAA;AA9BF;;AAiCA;EACE,sEAAA;EACA,sCAAA;EACA,4BAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;AA9BF;;AAiCA;EACE,yBAAA;EACA,WAAA;EACA,2BAAA;EACA,6CAAA;AA9BF;;AAiCA;EACE,WAAA;EACA,aAAA;EACA,6BAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;AA9BF;;AAiCA;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AA9BF;;AAiCA;EACE,aAAA;AA9BF;;AAiCA;EACE,aAAA;AA9BF;;AAiCA;EACE,aAAA;AA9BF;;AAiCA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,4BAAA;EACA,cAAA;EACA,0CAAA;EACA,2CAAA;AA9BF;;AAiCA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,4BAAA;EACA,cAAA;AA9BF;;AAiCA;EACE,SAAA;AA9BF;;AAiCA;EACE,YAAA;EACA,0CAAA;EACA,2CAAA;AA9BF;;AAiCA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,0CAAA;EACA,2CAAA;AA9BF;;AAiCA;EACE,cAAA;EACA,WAAA;AA9BF;;AAiCA;EACE,kBAAA;AA9BF;;AAiCA;EACE,cAAA;EACA,kBAAA;AA9BF;;AAiCA;EACE,SAAA;AA9BF;;AAkCA;EACE,cAAA;EACA,WAAA;AA/BF;;AAmCA;EACE,iBAAA;EACA,YAAA;EACA,aAAA;AAhCF;;AAmCA;EACE,mBAAA;EACA,4BAAA;EACA,kFAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AAhCF;;AAmCA;EACE,4BAAA;EACA,kFAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AAhCF;;AAmCA;EACE,4BAAA;EACA,kFAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AAhCF;;AAmCA;EACE,4BAAA;EACA,gFAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AAhCF;;AAmCA;EACE,WAAA;EACA,gBAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAhCF;;AAmCA;EACE,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAhCF;;AAmCA;EACE,oCAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AAhCF;;AAmCA;;;;;EAKE,eAAA;EACA,gBAAA;EACA,gBAAA;AAhCF;;AAmCA;EACE,gBAAA;AAhCF;;AAmCA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,4BAAA;EACA,gBAAA;AAhCF;;AAoCA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAjCF;;AAoCA;EACE,iBAAA;AAjCF;;AAoCA;EACE,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAjCF;;AAoCA;EACE,sBAAA;EACA,8BAAA;EACA,aAAA;AAjCF;;AAoCA;EACE,mBAAA;AAjCF;;AAoCA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAjCF;;AAoCA;EACE,sBAAA;AAjCF;;AAoCA;EACE,eAAA;EACA,cAAA;AAjCF;;AAoCA;EACE,aAAA;EACA,mBAAA;AAjCF;;AAoCA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAjCF;;AAoCA;EACE,WAAA;EACA,yBAAA;EACA,YAAA;AAjCF;;AAoCA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAjCF;;AAoCA;EACE,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AAjCF;;AAoCA;EACE,aAAA;AAjCF;;AAoCA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAjCF;;AAoCA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;AAjCF;;AAoCA;EACE,mBAAA;EACA,aAAA;EACA,SAAA;AAjCF;;AAoCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;AAjCF;;AAoCA;EACE,eAAA;AAjCF;;AAoCA;EACE,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;AAjCF;;AAoCA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAjCF;;AAoCA;EACE,cAAA;EACA,qBAAA;AAjCF;;AAoCA;EACE,SAAA;AAjCF;;AAoCA;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AAjCF;;AAoCA;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,4EAAA;EACA,wBAAA;AAjCF;;AAoCA;EACE,cAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAjCF;;AAoCA;EACE,SAAA;EACA,cAAA;AAjCF;;AAoCA;EACE,YAAA;AAjCF;;AAsCE;EACE,8BAAA;EACA,sBAAA;EACA,gDAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,gCAAA;AAnCJ;AAqCI;EACE,qBAAA;EACA,2BAAA;EACA,sBAAA;EACA,WAAA;AAnCN;AAsCI;EACE,WAAA;EACA,YAAA;AApCN;;AAyCA;EACE,gBAAA;EACA,iBAAA;AAtCF;AAyCE;EACE,UAAA;EACA,uBAAA;AAvCJ;AA0CE;EACE,uBAAA;EACA,mBAAA;AAxCJ;AA6CI;EACE,UAAA;AA3CN;AA8CI;EACE,oCAAA;AA5CN;;AAmDA,eAAA;AAEA;EAKE;IACE,gBAAA;EArDF;EAwDA;IACE,iBAAA;IACA,kBAAA;EAtDF;EAyDA;IACE,UAAA;EAvDF;EA0DA;IACE,YAAA;EAxDF;AACF;AA2DA;EACE;IACE,kBAAA;IACA,YAAA;IACA,aAAA;EAzDF;EA4DA;IACE,gBAAA;EA1DF;EA6DA;IACE,YAAA;IACA,aAAA;EA3DF;EA8DA;IACE,YAAA;IACA,aAAA;EA5DF;EA+DA;IACE,YAAA;IACA,aAAA;EA7DF;EAgEA;IACE,gBAAA;EA9DF;EAiEA;IACE,gBAAA;EA/DF;EAkEA;IACE,gBAAA;EAhEF;EAmEA;IACE,YAAA;IACA,iBAAA;EAjEF;EAoEA;IACE,UAAA;EAlEF;EAqEA;IACE,YAAA;EAnEF;EAsEA;IACE,UAAA;EApEF;EAuEA;IACE,eAAA;IACA,iBAAA;IACA,gBAAA;EArEF;EAwEA;IACE,eAAA;IACA,iBAAA;IACA,gBAAA;EAtEF;AACF;AAyEA,iBAAA;AAEA,8BAAA;AAEA;EACE;IACE,mBAAA;IACA,aAAA;EAzEF;EA4EA;IACE,eAAA;IACA,gBAAA;IACA,oBAAA;IACA,UAAA;IACA,mBAAA;IACA,kBAAA;IACA,iBAAA;EA1EF;EA6EA;IACE,eAAA;IACA,cAAA;IACA,gBAAA;IACA,kBAAA;IACA,UAAA;EA3EF;EA8EA;IACE,iBAAA;IACA,2BAAA;IACA,YAAA;EA5EF;EA+EA;IACE,UAAA;EA7EF;EAgFA;IACE,UAAA;IACA,iBAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;EA9EF;EAiFA;IACE,cAAA;IACA,cAAA;EA/EF;EAkFA;IACE,mEAAA;EAhFF;EAkFE;IACE,gBAAA;EAhFJ;EAoFA;IACE,qBAAA,EAAA,+CAAA;EAlFF;EAuFA;IACE,UAAA;IACA,cAAA;IACA,mBAAA;EArFF;EAwFA;IACE,WAAA;EAtFF;EAyFA;IACE,uBAAA;EAvFF;EA0FA;IACE,YAAA;IACA,mBAAA;EAxFF;EA2FA;IACE,YAAA;IACA,mBAAA;EAzFF;EA4FA;IACE,YAAA;EA1FF;EA6FA;IACE,UAAA;EA3FF;EA8FA;IACE,sBAAA;IACA,uBAAA;IACA,mBAAA;EA5FF;EA+FA;IACE,iBAAA;EA7FF;EAgGA;IACE,sBAAA;EA9FF;EAiGA;IACE,UAAA;IACA,gBAAA;EA/FF;EAkGA;IACE,WAAA;EAhGF;EAmGA;IACE,UAAA;EAjGF;EAoGA;IACE,YAAA;EAlGF;EAqGA;IACE,YAAA;EAnGF;EAsGA;IACE,YAAA;EApGF;AACF;AAwGA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AAtGF;;AAyGA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;AAtGF;;AAyGA;EACE,oCAAA,EAAA,iCAAA;EACA,uBAAA,EAAA,8BAAA;EACA,gCAAA;EACA,sCAAA;AAtGF;;AAyGA,+BAAA","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap\");\n\npre,\ncode {\n  white-space: pre-wrap;\n}\n\nbody .btn.btn-primary {\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 12px;\n\n}\n\nbody .btn.btn-dark {\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 12px;\n}\n\nbody .btn.btn-light {\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 12px;\n}\n\nbody .add-list-btn {\n  padding: 8px 26px;\n}\n\nbody .cancel-btn {\n  padding: 8px 26px;\n}\n\n::selection {\n  background-color: #0084ff !important;\n  color: #fff !important;\n}\n\nbody {\n  .over-menu {\n    overflow: inherit;\n  }\n\n  background-color: #f3f5f7;\n\n  margin: 0 !important;\n  padding: 0 !important;\n  font-family: \"Inter\",\n  sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #151718;\n  overflow-x: hidden;\n}\n\n.content {\n  width: 100%;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n.orders.row.no-padding>div {\n  padding-left: 0 !important;\n}\n\n#root>div>nav>div>div>a {\n  color: #fff;\n}\n\n.menus {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  list-style: none;\n}\n\n.menu-items {\n  position: relative;\n  font-size: 14px;\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.menu-items a {\n  display: block;\n  font-size: inherit;\n  color: inherit;\n  text-decoration: none;\n}\n\n.menu-items button {\n  display: flex;\n  align-items: center;\n  color: inherit;\n  font-size: inherit;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n}\n\nbutton span {\n  margin-left: 3px;\n}\n\n.menu-items>a,\n.menu-items button {\n  text-align: left;\n  padding: 0.7rem 1rem;\n}\n\n.arrow::after {\n  content: \"\";\n  display: inline-block;\n  margin-left: 0.28em;\n  vertical-align: 0.09em;\n  border-top: 0.42em solid;\n  border-right: 0.32em solid transparent;\n  border-left: 0.32em solid transparent;\n}\n\n.dropdown {\n  position: absolute;\n  right: 0;\n  left: auto;\n  font-size: 0.875rem;\n  padding: 0.5rem 0;\n  list-style: none;\n  display: none;\n  min-width: 100px;\n  border-radius: 0.2rem;\n}\n\n.dropdown-submenu {\n  position: absolute;\n  right: 0;\n  left: auto;\n  box-shadow: 0 10px 15px -3px rgba(46, 41, 51, 0.08), 0 4px 6px -2px rgba(71, 63, 79, 0.16);\n  font-size: 0.875rem;\n  padding: 0.5rem 0;\n  list-style: none;\n}\n\n.dropdown.show {\n  display: flex;\n  position: absolute;\n  justify-content: flex-end;\n  z-index: auto;\n}\n\n.dropdown.child {\n  min-width: 10rem;\n}\n\n.dropdown .dropdown-submenu {\n  background-color: #5c84bf;\n  color: #fff;\n  display: none;\n}\n\n.dropdown .dropdown-submenu.show {\n  display: block;\n  z-index: 2;\n}\n\n.aaa {\n  overflow: inherit;\n}\n\n.pagination-table>div:nth-child(2) {\n  overflow: inherit;\n}\n\n.containerLoginImage {\n  background: #141718;\n  min-height: 100vh;\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: center;\n  color: #fff;\n  padding: 20px;\n  flex-direction: column;\n  align-items: flex-start;\n  align-content: center;\n}\n\n.containerLoginImage h2 {\n  font-size: 48px;\n  font-weight: 700;\n  letter-spacing: -1px;\n  width: 90%;\n  margin-bottom: 50px;\n}\n\n.containerLoginImage h4 {\n  font-size: 24px;\n  color: #e8ecef;\n  font-weight: 400;\n}\n\n.left-image-login {\n  width: 100%;\n  height: 330px;\n  margin-top: 60px;\n}\n\n.containerLoginForm {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n}\n\n.containerLoginForm .form-login {\n  width: 400px;\n  margin-top: 40px;\n}\n\n.form-login label {\n  display: none;\n}\n\n.form-login .name-input {\n  background: #F3F5F7 url(\"../Images/name.svg\") no-repeat 16px center;\n  padding: 14px 38px;\n  color: #181a20;\n  font-size: 14px;\n  font-weight: 500;\n  border: none;\n  border-radius: 12px;\n\n  &::placeholder {\n    color: #B1B3B6;\n  }\n}\n\n.form-login .email-input {\n  background: #F3F5F7 url(\"../Images/email-icon.svg\") no-repeat 14px center;\n  padding: 14px 40px;\n  color: #181a20;\n  font-size: 14px;\n  font-weight: 500;\n  border: none;\n  border-radius: 12px;\n\n  &::placeholder {\n    color: #B1B3B6;\n\n  }\n}\n\n.form-login .password-input {\n  background: #F3F5F7 url(\"../Images/lock-icon.svg\") no-repeat 16px center;\n  padding: 14px 38px;\n  color: #181a20;\n  font-size: 14px;\n  font-weight: 500;\n  border: none;\n  border-radius: 12px;\n\n  &::placeholder {\n    color: #B1B3B6;\n  }\n}\n\n.form-login button {\n  height: auto !important;\n  max-width: inherit !important;\n  padding: 12px 20px;\n  font-size: 14px;\n}\n\n.forgot-pass-link {\n  margin-bottom: 20px;\n}\n\n.forgot-pass-link a {\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.login-body {\n  padding: 20px;\n}\n\n.loginForm {\n  max-width: 608px;\n  padding: 5vh;\n  border-radius: 10px;\n}\n\n.cs-login-form {\n  display: flex;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  flex-direction: row;\n}\n\n.loginForm>h2 {\n  font-style: normal;\n  font-weight: 700;\n  line-height: 110%;\n  display: flex;\n  align-items: center;\n  color: #ffffff;\n  margin-bottom: 3rem;\n}\n\ninput.loginInput,\ninput.loginInput:focus {\n  padding: 0px 20px;\n  height: 56px;\n  color: #9e9e9e;\n  background-color: #181a20;\n  border-radius: 12px;\n}\n\ninput.passwordInput {\n  margin-bottom: 3rem;\n}\n\n.submitLogin,\n.submitLogin:hover {\n  min-width: 200px;\n  max-width: 380px;\n  height: 42px;\n  background: #0084ff;\n  border-radius: 1rem;\n  font-weight: 700;\n  letter-spacing: 0.2px;\n  color: #ffffff;\n  margin-bottom: 1rem;\n}\n\n.submitLogin:hover {\n  background: #004cff;\n}\n\n.loginAlignCenter {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n}\n\n.signUpText {\n  font-size: 14px;\n  color: #f5f5f5;\n}\n\n.signUpLink {\n  font-weight: 600;\n  color: #0084ff;\n  text-decoration: none;\n}\n\n.signUpLink:hover {\n  color: #004cff;\n  cursor: pointer;\n}\n\n.form-group {\n\n  input,\n  textarea {\n    &::-webkit-selection {\n      color: #fff;\n      background: rgba(255, 255, 255, 0.08);\n    }\n\n    &::-moz-selection {\n      color: #fff;\n      background: rgba(255, 255, 255, 0.08);\n    }\n\n    &::selection {\n      color: #fff;\n      background: rgba(255, 255, 255, 0.08);\n    }\n  }\n}\n\n.buttonmod,\n.buttonmod:hover {\n  background-color: #22bb9c;\n  border-radius: 50px;\n  font-weight: 700;\n  font-size: 16px;\n  letter-spacing: 0.2px;\n  color: #ffffff;\n  margin-bottom: 1rem;\n\n  .buttonmod:hover {\n    background-color: #22bb9c96;\n  }\n}\n\n.row {\n  .form-group {\n    margin-bottom: 15px;\n\n    label {\n      margin-left: 5px;\n      margin-bottom: 5px;\n    }\n  }\n}\n\ninput[type=\"tel\"] {\n  height: 56px;\n  width: 100%;\n  background-color: #181a20;\n  border: none;\n  color: #757575;\n  padding: 6px 12px;\n}\n\n.product-image {\n  background-size: contain !important;\n  background-repeat: no-repeat !important;\n}\n\n// General Overwrites\n\nbody .custom-container {\n  width: 100%;\n  max-width: 100%;\n  align-items: flex-start;\n  justify-content: space-around;\n  margin: 0;\n  padding: 20px;\n  background-color: #151718;\n}\n\n.login-container {\n  width: 100%;\n  display: flex;\n  height: 95vh;\n  flex-direction: column;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: nowrap;\n}\n\n.main-header {\n  border-bottom: solid 1px #35383f;\n  padding-bottom: 1px;\n  margin-left: -40px;\n  padding-left: 40px;\n  margin-bottom: 40px;\n}\n\n.main-content {\n  background: #fff;\n  border-radius: 20px;\n  overflow: hidden;\n  flex-wrap: nowrap;\n  align-content: flex-start;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\nbody .toggle-logo {\n  margin-bottom: 40px;\n  margin-top: 20px;\n}\n\nbody .toggle-logo {\n  display: flex;\n  flex-flow: row-reverse;\n  width: 100%;\n  align-content: center;\n  align-items: center;\n  justify-content: flex-end;\n}\n\nbody .toggle-logo span:first-of-type {\n  display: block;\n  width: 50px !important;\n  height: 50px !important;\n  transform: rotate(0deg) !important;\n}\n\nbody .toggle-logo span:nth-of-type(n + 2) {\n  display: none;\n}\n\nbody .open-nav span:first-of-type {\n  background-color: transparent;\n  background-image: url(\"../Svgs/collapse.svg\");\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\nbody .closed-nav span:first-of-type {\n  background-color: transparent;\n  background-image: url(\"../Svgs/collapse-2.svg\");\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\nbody .toggle-logo img {\n  display: flex;\n  width: 65%;\n  margin-left: 20px;\n}\n\nbody .react-datepicker {\n  border: solid 1px #1f222a;\n}\n\nhtml body .react-datepicker__day--selected {\n  background-color: #37bb9c;\n}\n\nbody .react-datepicker__day--in-selecting-range,\nbody .react-datepicker__day--in-range {\n  background-color: #1f222a;\n}\n\nbody .react-datepicker__header {\n  background-color: #37bb9c;\n}\n\nbody .react-datepicker__navigation-icon::before,\nbody .react-datepicker__navigation:hover *::before {\n  border-color: #1f222a;\n  margin-top: 8px;\n}\n\nbody .react-datepicker__day--in-selecting-range:hover,\nbody .react-datepicker__day--in-range:hover {\n  background-color: #37bb9c;\n}\n\nbody .bg-success-mod {\n  background-color: #37bb9c;\n}\n\nbody .rectangle {\n  font-weight: 700;\n}\n\nbody .form-group label,\n.mod-label,\n.label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #181a20;\n}\n\nbody .PhoneInputInput {\n  &:focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.25rem rgb(55 187 156 / 40%);\n  }\n\n  border-radius: 5px;\n}\n\nbody .mod-color-picker {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\nbody .md-green-button {\n  background-color: #37bb9c;\n  border: none;\n  border-radius: 20px;\n  font-size: 12px;\n  padding: 5px 20px;\n  font-weight: 600;\n}\n\nbody .md-green-button:hover,\nbody .md-green-button:focus-visible {\n  background-color: #1a715d;\n}\n\nbody .sidenav---navtext---1AE_f {\n  color: #b3b7b9 !important;\n  font-weight: 700;\n  align-items: center;\n\n}\n\nbody .sidenav---sidenav-nav---3tvij {\n  max-height: 70vh;\n  height: calc(100% - 350px);\n  overflow-y: scroll;\n}\n\nbody .left-menu .sidenav---selected---1EK3y {\n  background: linear-gradient(270deg, #323337 50%, rgba(70, 79, 111, 0.5) 100%);\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1), inset 0px 1px 0px rgba(255, 255, 255, 0.05);\n  margin: 0 15px;\n  border-radius: 10px;\n}\n\nbody .sidenav---sidenav-nav---3tvij>.sidenav---sidenav-navitem---uwIJ- {\n  margin: 0 15px;\n  border-radius: 10px;\n  height: 44px;\n  margin-bottom: 10px;\n}\n\nhtml body .sidenav---sidenav-nav---3tvij>.sidenav---sidenav-navitem---uwIJ-:hover {\n  display: flex;\n  // overflow: hidden;\n  background-color: #323337 !important;\n  align-items: center;\n}\n\nbody .sidenav---sidenav-nav---3tvij>.sidenav---sidenav-navitem---uwIJ->.sidenav---navitem---9uL5T {\n  border-radius: 10px !important;\n  display: flex;\n  background-color: transparent;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  gap: 15px;\n  align-items: center;\n  padding-left: 12px;\n\n}\n\nbody .left-menu .sidenav---selected---1EK3y .sidenav---navitem---9uL5T {\n  height: 44px;\n  line-height: 44px !important;\n}\n\n.sidenav---sidenav-navitem---uwIJ-:hover,\n.sidenav---navitem---9uL5T:hover,\nbody .sidenav---sidenav-nav---3tvij>.sidenav---sidenav-navitem---uwIJ->.sidenav---navitem---9uL5T:hover {\n  background-color: transparent !important;\n  box-shadow: none !important;\n}\n\nbody .sidenav---sidenav-nav---3tvij>.sidenav---sidenav-navitem---uwIJ->.sidenav---navitem---9uL5T .sidenav---navicon---3gCRo {\n  height: 46px;\n  line-height: 44px;\n  width: 34px;\n}\n\nbody .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL {\n  min-width: 300px;\n}\n\nbody .left-menu .sidenav---selected---1EK3y .sidenav---navtext---1AE_f {\n  color: #fff !important;\n  font-weight: 700;\n}\n\nbody .form-control:focus {\n  box-shadow: 0 0 0 0.25rem rgb(55 187 156 / 40%);\n}\n\n.chat-header {\n  background: #fefefe;\n  border-bottom: 1px solid #e8ecef;\n  box-shadow: 0px 12px 28px -12px rgba(0, 0, 0, 0.1);\n  padding: 20px 20px;\n}\n\n.chat-header h4 {\n  margin-bottom: 0;\n  color: #141718;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: -1px;\n}\n\n.conversation-block {\n  padding: 0 0 0 12px;\n  box-shadow: 0px 24px 60px rgba(0, 0, 0, 0.1);\n  border-right: 1px solid #e8ecef;\n}\n\n.conversation-block .container {\n  padding: 40px;\n}\n\n.conversation-block .prompt-box {\n  padding: 0 30px 10px 30px;\n}\n\n.history-block {\n  margin-left: 0 !important;\n  background-color: #f7f7f7;\n  padding-left: 00px;\n}\n\n.history-block .container {\n  padding: 0px 30px 10px 30px;\n}\n\n.new-chat-block {\n  height: 100px;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n  padding-right: 30px;\n  padding-left: 30px;\n}\n\n.new-chat-block button {\n  width: 100%;\n}\n\n.history-block .conversation-list-item .chat-content {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  margin: 0;\n  padding-right: 1em;\n  font-size: 14px;\n  color: #6c7275;\n}\n\n.history-block .conversation-list-item .chat-content::after {\n  content: \"...\";\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  padding-left: 0.5em;\n  background: linear-gradient(to right, rgba(255, 255, 255, 0), white 50%);\n}\n\n.meta-chat-info {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  align-content: center;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.meta-chat-info .user-photo img {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n}\n\n.meta-chat-info .generate-time {\n  font-size: 12px;\n  color: #6c7275;\n}\n\n.robot-avatar {\n  background-color: #2d84ff;\n  background-size: 80% !important;\n  background-repeat: no-repeat;\n}\n\n.thinking-dots-loader {\n  width: 42px;\n  height: 15px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.dots {\n  width: 9.6px;\n  height: 9.6px;\n  background: #141718;\n  color: #141718;\n  border-radius: 50%;\n  box-shadow: 16px 0, -16px 0;\n  animation: dots-u8fzftsm 1s infinite linear alternate;\n}\n\n@keyframes dots-u8fzftsm {\n  0% {\n    box-shadow: 16px 0, -16px 0;\n  }\n\n  33% {\n    box-shadow: 16px 0, -16px 0 rgba(20, 23, 24, 0.13);\n    background: rgba(20, 23, 24, 0.13);\n  }\n\n  66% {\n    box-shadow: 16px 0 rgba(20, 23, 24, 0.13), -16px 0;\n    background: rgba(20, 23, 24, 0.13);\n  }\n}\n\n.prompt-data {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: center;\n  align-items: center;\n  height: 40px;\n  justify-content: flex-start;\n  gap: 20px;\n}\n\n.prompt-data small {\n  font-size: 12px;\n  color: #b4b9ba;\n}\n\n.robot-meta-info {\n  font-size: 12px;\n  color: #b4b9ba;\n  font-weight: 500;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 4px;\n  padding-left: 12px;\n  min-width: 750px;\n  width: fit-content;\n}\n\n.user-meta-info {\n  font-size: 12px;\n  color: #b4b9ba;\n  font-weight: 500;\n  display: flex;\n  flex-direction: row-reverse;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: space-between;\n  align-items: center;\n  // padding-left: 12px;\n  // min-width: 720px;\n  width: 100%;\n  margin-right: 20px;\n}\n\n.prompt-data .thinking-dots-loader {\n  margin-bottom: 0;\n}\n\n.tab-content {\n  display: flex;\n  flex-direction: row;\n  gap: 0px;\n  flex-wrap: nowrap;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n}\n\n.googlesignin {\n  width: 100% !important;\n  border: solid 2px #E7ECEE !important;\n  display: flex !important;\n  justify-content: center;\n  border-radius: 12px !important;\n  overflow: hidden;\n  box-shadow: none !important;\n}\n\n.login-options {\n  margin: 50px 0;\n  background-color: #F3F5F7;\n  border-radius: 12px;\n  padding: 6px;\n\n  .btn-default {\n    width: 190px;\n    height: 40px;\n    border-radius: 8px;\n    padding: 8px 24px 8px 24px;\n    border: none;\n    color: #6C7275;\n    font-weight: 500;\n    font-size: 14px;\n\n    &.active {\n      border: none;\n      gap: 8px;\n      background-color: #fff;\n      color: #232627;\n      border-radius: 8px;\n      box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.07), 0px 4px 2px 0px #FFF inset;\n    }\n  }\n}\n\nbody .nav-tabs .nav-link {\n  border: none;\n  background-color: #f3f5f7;\n  margin-bottom: 12px;\n  min-height: 44px;\n  border-radius: 10px;\n  font-weight: 700;\n  padding-left: 20px;\n  padding-right: 20px;\n  margin-right: 14px;\n}\n\nbody .nav-tabs .nav-link .trait-button {\n  font-size: 12px;\n  font-weight: 600;\n}\n\nbody .nav-tabs .nav-link.active {\n  background-color: #000;\n}\n\nbody .nav-tabs .nav-link .icon-tab-img svg path {\n  stroke: #7C8285;\n}\n\nbody .nav-tabs .nav-link.active .icon-tab-img path {\n  stroke: #fff;\n}\n\nbody .nav-tabs .nav-link .icon-tab-txt svg {\n  stroke: #7C8285;\n}\n\nbody .nav-tabs .nav-link.active .icon-tab-txt svg {\n  stroke: #fff;\n}\n\nbody .nav-tabs .nav-link .button-text {\n  color: #7C8285;\n  font-size: 14px;\n  font-weight: 600;\n  padding-left: 10px;\n}\n\nbody .nav-tabs .nav-link.active .button-text {\n  color: #fff;\n}\n\nbody .nav-tabs {\n  border-bottom: none;\n}\n\nbody .nav-tabs .nav-link:hover {\n  margin-bottom: -1px;\n}\n\n.prompt-box .form-group label {\n  display: none;\n}\n\n.prompt-box textarea {\n  border-radius: 10px;\n  min-height: 42px;\n  resize: none;\n  font-size: 14px;\n  padding: 10px 15px;\n  font-weight: 500;\n}\n\n.prompt-box textarea::placeholder {\n  color: #B6B8B9;\n}\n\nbody .form-control:focus {\n  box-shadow: 0 1px 2px 1px rgba(142, 142, 142, 0.3);\n  // border: none !important;\n}\n\n.generate-button {\n  background: #0084ff url(\"../Images/generate.svg\") no-repeat;\n  background-position: 95px center;\n  padding: 8px 50px 9px 20px !important;\n  border-radius: 10px !important;\n  margin-bottom: 18px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.prompt-box-inner {\n  display: flex;\n  align-items: end;\n  gap: 10px;\n}\n\n.prompt-box-inner .prompt-box-input {\n  width: 100%;\n}\n\n.new-chat-button {\n  background-position: center;\n  padding: 7px 20px 7px 20px !important;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: nowrap;\n  flex-direction: row;\n  align-content: center;\n  gap: 10px;\n  max-width: 250px;\n  border: solid 2px #0084ff;\n  background-color: transparent;\n  color: #0084ff;\n}\n\n.new-chat-button svg {\n  stroke: #0084ff !important;\n}\n\n.new-chat-button:hover svg {\n  stroke: #fff !important;\n}\n\n.chat-history-header {\n  padding-top: 20px;\n}\n\n.chat-history-header .profile {\n  background: #fff;\n  border-bottom: 1px solid #e8ecef;\n  padding: 15px 20px 14px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: space-around;\n  gap: 10px;\n}\n\n.chat-history-header .profile button {\n  background-color: #181a20;\n  border: none;\n  font-weight: 600;\n  color: #fff;\n  font-size: 16px;\n  border-radius: 12px;\n}\n\n.chat-history-header .profile .top-profile {\n  position: relative;\n  width: 50px;\n  height: 40px;\n}\n\n.chat-history-header .profile .top-profile img {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n}\n\n.chat-history-header .profile .top-profile .active-user {\n  background-color: #22bb9c;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  position: absolute;\n  bottom: 0px;\n  right: 10px;\n  border: solid 3px #fff;\n}\n\n.chat-history-header .sub-header {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 30px;\n  color: #919597;\n}\n\n.chat-history-header .sub-header button {\n  background-image: url(\"../Svgs/trash.svg\");\n  background-repeat: no-repeat;\n  background-color: transparent;\n  height: 26px;\n  width: 26px;\n  border: none;\n}\n\n.chat-history-header .sub-header .counter {\n  background-color: #e8ecef;\n  border-radius: 6px;\n  font-size: 12px;\n  padding: 4px 8px;\n  color: #6c7275;\n  font-weight: 500;\n}\n\n.chat-history-header .sub-header>div {\n  display: flex;\n  flex-wrap: nowrap;\n  flex-direction: row;\n  align-content: center;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10px;\n}\n\n.chat-history-header .sub-header>div h6 {\n  margin-bottom: 0;\n}\n\n.custom-content {\n  height: 95vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.header-home {\n  text-align: center;\n  margin-top: 100px;\n  margin-bottom: 50px;\n}\n\n.header-home h1 {\n  font-size: 42px;\n  font-weight: 700;\n}\n\n.header-home p {\n  color: #6c7275;\n  font-size: 22px;\n}\n\n.content-left {\n  width: 60px;\n  height: 60px;\n  text-indent: -99999999px;\n  overflow: hidden;\n}\n\n.content-right {\n  background: url(\"../Svgs/arrow-narrow-right.svg\") no-repeat;\n  text-indent: -99999999px;\n  overflow: hidden;\n  width: 30px;\n  height: 30px;\n}\n\n.generate-text {\n  background: url(\"../Svgs/generate-text.svg\") no-repeat;\n}\n\n.generate-img {\n  background: url(\"../Svgs/generate-image.svg\") no-repeat;\n}\n\n.generate-code {\n  background: url(\"../Svgs/generate-code.svg\") no-repeat;\n}\n\n.generate-video {\n  background: url(\"../Svgs/generate-video.svg\") no-repeat;\n}\n\n.generate-voice {\n  background: url(\"../Svgs/generate-voice.svg\") no-repeat;\n}\n\n.type-text {\n  background: #e8ecef url(\"../Svgs/text-icon.svg\") no-repeat;\n  background-position: right 10px center;\n  padding: 4px 30px 4px 15px;\n  color: #232627;\n  border-radius: 6px;\n  font-weight: 700;\n  font-size: 12px;\n}\n\n.type-image {\n  background: #e8ecef url(\"../Svgs/image-icon.svg\") no-repeat;\n  background-position: right 10px center;\n  padding: 4px 30px 4px 15px;\n  color: #232627;\n  border-radius: 6px;\n  font-weight: 700;\n  font-size: 12px;\n}\n\n.variation-btn {\n  background: #141718 url(\"../Svgs/image-check.svg\") no-repeat;\n  background-position: right 10px center;\n  padding: 10px 38px 10px 15px;\n  color: #fff;\n  font-weight: 700;\n  font-size: 12px;\n  border: none;\n  border-radius: 10px;\n}\n\n.upscale-btn {\n  background: #fff url(\"../Svgs/plus-circle.svg\") no-repeat;\n  background-position: right 10px center;\n  padding: 10px 38px 10px 15px;\n  color: #141718;\n  font-weight: 700;\n  font-size: 12px;\n  border: none;\n  border-radius: 10px;\n}\n\n.variation-btn:hover {\n  background-color: #141718;\n  color: #fff;\n  transform: translateY(-2px);\n  box-shadow: 0 0 10px rgba(255, 255, 255, 0.4);\n}\n\n.upscale-btn:hover,\n.upscale-btn.btn-check:checked+.btn,\n.upscale-btn.btn.active,\n.upscale-btn.btn.show,\n.upscale-btn.btn:first-child:active,\n:not(.btn-check)+.upscale-btn.btn:active {\n  background-color: #ffffff !important;\n  color: #141718 !important;\n  transform: translateY(-2px);\n  box-shadow: 0 0 10px rgba(255, 255, 255, 0.4);\n}\n\n.download-btn {\n  background: #141718 url(\"../Svgs/download.svg\") no-repeat;\n  background-position: right 10px center;\n  padding: 10px 38px 10px 15px;\n  color: #fff;\n  font-weight: 700;\n  font-size: 12px;\n  border: none;\n  border-radius: 10px;\n}\n\n.download-btn:hover {\n  background-color: #141718;\n  color: #fff;\n  transform: translateY(-2px);\n  box-shadow: 0 0 10px rgba(255, 255, 255, 0.4);\n}\n\n.image-actions {\n  width: 100%;\n  display: flex;\n  justify-content: space-evenly;\n  align-content: flex-end;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: flex-end;\n  position: absolute;\n}\n\n.full-image {\n  width: 720px;\n  height: 720px;\n  overflow: hidden;\n  border-radius: 20px;\n}\n\n.conversation-item .blur-bg {\n  display: none;\n}\n\n.image-variate-container .blur-bg {\n  display: flex;\n}\n\n.image-variate-container .full-image .blur-bg {\n  display: flex;\n}\n\n.full-image .blur-bg {\n  position: relative;\n  width: 100%;\n  height: 58px;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n  padding-bottom: 10px;\n  align-items: center;\n  transition: bottom 0.3s ease;\n  bottom: -300px;\n  border-bottom-left-radius: 20px !important;\n  border-bottom-right-radius: 20px !important;\n}\n\n.blur-bg {\n  position: relative;\n  width: 100%;\n  height: 58px;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n  padding-bottom: 10px;\n  align-items: center;\n  transition: bottom 0.3s ease;\n  bottom: -100px;\n}\n\n.quadrant:hover .blur-bg {\n  bottom: 0;\n}\n\n.full-image:hover .blur-bg {\n  bottom: 58px;\n  border-bottom-left-radius: 20px !important;\n  border-bottom-right-radius: 20px !important;\n}\n\n.blur-bg::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  backdrop-filter: blur(10px);\n  border-bottom-left-radius: 20px !important;\n  border-bottom-right-radius: 20px !important;\n}\n\n.default-response.bot-chat {\n  min-width: 1px;\n  width: 100%;;\n}\n\n.default-response.bot-chat .image-complete .full-image {\n  position: relative;\n}\n\n.default-response.bot-chat .image-complete .full-image .blur-bg {\n  bottom: -110px;\n  position: absolute;\n}\n\n.default-response.bot-chat .image-complete .full-image:hover .blur-bg {\n  bottom: 0;\n}\n\n\n.default-response.me-chat {\n  min-width: 1px;\n  width: 100%;\n  // float: right;\n}\n\n.ai-image {\n  max-height: 720px;\n  width: 720px;\n  height: 720px;\n}\n\n.profile-input-option.name-input {\n  border-radius: 12px;\n  padding: 14px 16px 14px 46px;\n  background: #F3F5F7 url(\"../Images/user-normal.svg\") no-repeat 16px center;\n  font-size: 14px;\n  font-style: normal;\n  color: #141718\n}\n\n.profile-input-option.email-input {\n  padding: 14px 16px 14px 46px;\n  background: #F3F5F7 url(\"../Images/user-normal.svg\") no-repeat 16px center;\n  font-size: 14px;\n  font-style: normal;\n  color: #141718\n}\n\n.profile-input-option.location-input {\n  padding: 14px 16px 14px 46px;\n  background: #F3F5F7 url(\"../Images/location.svg\") no-repeat 16px center;\n  font-size: 14px;\n  font-style: normal;\n  color: #141718\n}\n\n.profile-input-option.bio-input {\n  padding: 14px 16px 14px 46px;\n  background: #F3F5F7 url(\"../Images/user-check.svg\") no-repeat 16px 16px;\n  font-size: 14px;\n  font-style: normal;\n  color: #141718\n}\n\n.big-save-button {\n  width: 100%;\n  text-align: left;\n  padding: 10px 20px 10px 20px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 12px;\n  text-align: center;\n}\n\n.add-button {\n  padding: 10px 20px 10px 20px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 12px;\n}\n\n.big-delete-btn {\n  background-color: #D84C10 !important;\n  border: none !important;\n  padding: 10px 20px;\n  font-weight: 600;\n  width: 100%;\n}\n\n.delete-account-tab h2,\n.edit-profile h2,\n.password-tab h2,\n.members-tab h2,\n.applications-tab h2 {\n  font-size: 28px;\n  font-weight: 700;\n  margin-bottom: 0;\n}\n\n.members-tab {\n  overflow-y: auto;\n}\n\nbody .delete-account-tab p {\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  color: #6C7275;\n  padding-left: 0px !important;\n  margin-top: 20px;\n\n}\n\nbody .delete-account-tab small.dark {\n  color: #141718;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n}\n\n.configuration-content {\n  min-height: 500px;\n}\n\n.hootsuite-button {\n  background-color: #141718;\n  color: #fff;\n  font-weight: 600;\n  padding: 4px 12px;\n  border-radius: 8px;\n  margin-top: 4px;\n  cursor: pointer;\n}\n\n.post-preview {\n  background-color: #fff;\n  border-radius: 12px !important;\n  padding: 20px;\n}\n\n.message-upload {\n  margin-bottom: 20px;\n}\n\n.message-upload h5 {\n  color: #232627;\n  font-size: 15px;\n  margin-bottom: 0;\n}\n\nbody .upload-components .custom-file-upload>.img-wrap {\n  background-image: none;\n}\n\n.message-upload small {\n  font-size: 12px;\n  color: #909597\n}\n\n.upload-components {\n  display: flex;\n  flex-direction: row;\n}\n\n.divider-login {\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  align-items: center;\n  gap: 24px;\n  margin-top: 30px;\n}\n\n.line-login {\n  height: 1px;\n  background-color: #B6B8B9;\n  width: 160px;\n}\n\n.divider-login h5 {\n  color: #B6B8B9;\n  font-size: 12px;\n  margin-bottom: 0;\n}\n\n.chat-counter {\n  padding: 12px;\n  background-color: #242627;\n  height: 14px !important;\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: nowrap;\n  margin-right: 16px;\n  border-radius: 8px;\n  color: #6C7274 !important;\n}\n\n.custom-checkbox input[type=\"checkbox\"] {\n  display: none;\n}\n\n.custom-checkbox span {\n  position: relative;\n  display: block;\n  width: 20px;\n  height: 20px;\n  border: 2px solid #B6B8B9;\n  border-radius: 4px;\n}\n\n.custom-checkbox input[type=\"checkbox\"]:checked+span:after {\n  content: '';\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  background: #2D84FF;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  border-radius: 3px;\n}\n\n.robot-saying {\n  flex-direction: row;\n  display: flex;\n  gap: 20px;\n}\n\n.form-login .action-title {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  justify-content: flex-start;\n  margin-bottom: 20px;\n}\n\n.form-login .action-title img {\n  cursor: pointer;\n}\n\n.form-login h5 {\n  font-weight: 600;\n  color: #141718;\n  letter-spacing: -0.5px;\n  margin-bottom: 0px;\n}\n\n.login-link {\n  font-size: 12px;\n  color: #6C7275;\n  font-weight: 400;\n}\n\n.login-link a {\n  color: #343839;\n  text-decoration: none;\n}\n\n.denied-content p {\n  margin: 0;\n}\n\n.denied-content p a {\n  color: #141718;\n  margin-top: 10px;\n  display: flex;\n  align-content: center;\n  align-items: center;\n}\n\n.denied-content p a::after {\n  content: \"\";\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  margin-left: 5px;\n  background: url(\"../Images/setinha.svg\") no-repeat center center;\n  background-size: contain;\n}\n\n.html {\n  display: block;\n  background-color: #131718;\n  padding: 20px;\n  border-radius: 10px;\n  margin-bottom: 20px;\n}\n\n.html p {\n  margin: 0;\n  color: #f3f5f7;\n}\n\n.login-button-container {\n  width: 430px;\n}\n\n\n.curvy-textarea {\n  textarea {\n    border-radius: 20px !important;\n    border: 1px solid #444; // Darker border for contrast\n    background-color: #29282809; // Slightly lighter than black\n    color: #ddd; // Light gray text for readability\n    padding: 12px 15px;\n    outline: none;\n    transition: all 0.3s ease-in-out;\n\n    &:focus {\n      border-color: #818181; // A cool blue focus border\n      box-shadow: 0 0 7px #818181; // Soft glow, no white\n      background-color: #222; // Keeps the dark background\n      color: #ddd; // Ensures text remains readable\n    }\n\n    &::placeholder {\n      color: #888; // Subtle placeholder for readability\n      opacity: 0.7;\n    }\n  }\n}\n\n.chat-container {\n  overflow-y: auto; // Enables scrolling\n  max-height: 100vh; // Adjust height as needed\n\n  // Hide scrollbar by default\n  &::-webkit-scrollbar {\n    width: 2px; // Keeps it very thin\n    background: transparent; // Fully hidden\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: transparent; // Invisible by default\n    border-radius: 10px;\n  }\n\n  // Show scrollbar only on hover\n  &:hover {\n    &::-webkit-scrollbar {\n      width: 4px; // Slightly increase width on hover\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: rgba(255, 255, 255, 0.3); // Visible on hover\n    }\n  }\n}\n\n\n\n/* RESPONSIVE */\n\n@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {\n  // body .user-meta-info {\n  //   // min-width: 684px;\n  // }\n\n  body .robot-meta-info {\n    min-width: 746px;\n  }\n\n  body .prompt-box {\n    margin-left: 10px;\n    margin-right: 20px;\n  }\n\n  body .prompt-box textarea {\n    width: 96%;\n  }\n\n  body .blur-bg {\n    height: 60px;\n  }\n}\n\n@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {\n  body .image-variate-container {\n    position: relative;\n    width: 490px;\n    height: 490px;\n  }\n\n  body .default-response.bot-chat {\n    min-width: 530px;\n  }\n\n  body .quadrant {\n    width: 245px;\n    height: 245px;\n  }\n\n  body .full-image {\n    width: 490px;\n    height: 490px;\n  }\n\n  body .full-image>div {\n    width: 490px;\n    height: 490px;\n  }\n\n  body .default-response.me-chat {\n    min-width: 530px;\n  }\n\n  body .user-meta-info {\n    min-width: 494px;\n  }\n\n  body .robot-meta-info {\n    min-width: 530px;\n  }\n\n  body .prompt-box {\n    width: 566px;\n    margin-left: 10px;\n  }\n\n  body .prompt-box textarea {\n    width: 90%;\n  }\n\n  body .blur-bg {\n    height: 70px;\n  }\n\n  body .image-actions {\n    width: 90%;\n  }\n\n  body .variation-btn {\n    font-size: 11px;\n    line-height: 13px;\n    text-align: left;\n  }\n\n  body .upscale-btn {\n    font-size: 11px;\n    line-height: 13px;\n    text-align: left;\n  }\n}\n\n/* MOBILE LOGIN */\n\n/* Mobile devices (portrait) */\n\n@media only screen and (max-width: 480px) {\n  .containerLoginImage {\n    align-items: center;\n    display: none;\n  }\n\n  .containerLoginImage h2 {\n    font-size: 48px;\n    font-weight: 700;\n    letter-spacing: -1px;\n    width: 90%;\n    margin-bottom: 50px;\n    text-align: center;\n    line-height: 44px;\n  }\n\n  .containerLoginImage h4 {\n    font-size: 20px;\n    color: #e8ecef;\n    font-weight: 400;\n    text-align: center;\n    width: 90%;\n  }\n\n  .login-container {\n    padding-top: 40px;\n    justify-content: flex-start;\n    height: 100%;\n  }\n\n  .login-body {\n    padding: 0;\n  }\n\n  .login-options {\n    width: 85%;\n    margin: 20px auto;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .login-button-container {\n    max-width: 82%;\n    margin: 0 auto;\n  }\n\n  .transition-container {\n    transition: margin-top 0.5s ease-in-out, transform 0.5s ease-in-out;\n  \n    &.moved-down {\n      margin-top: auto; // Moves the container down smoothly\n    }\n  }\n\n  .logo img {\n    transform: scale(1.5); /* Increase the size without affecting layout */\n  }\n\n  .containerLoginForm {}\n\n  .login-body .main-content {\n    width: 90%;\n    margin: 0 auto;\n    margin-bottom: 30px;\n  }\n\n  .login-body .main-content.reset {\n    width: 100%;\n  }\n\n  .form-login .action-title {\n    justify-content: center;\n  }\n\n  .containerLoginForm .form-login {\n    width: 340px;\n    margin-bottom: 20px;\n  }\n\n  .plan-container .plan-option {\n    margin: 10px;\n    border-radius: 20px;\n  }\n\n  .plan-container .plan-option.best-option {\n    margin: 10px;\n  }\n\n  .features-list>div {\n    width: 90%;\n  }\n\n  .container .payment-info .stripe-container {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  body .payment-info .plan-discriminator {\n    padding-top: 40px;\n  }\n\n  body .payment-info .periodicity-opt {\n    flex-direction: column;\n  }\n\n  body .payment-info .stripe-elements {\n    width: 90%;\n    margin-top: 40px;\n  }\n\n  body .periodicity-container {\n    width: 100%;\n  }\n\n  body .industry-container .title-container {\n    width: 80%;\n  }\n\n  body .centered-industry-items .input-container {\n    width: 300px;\n  }\n\n  body .centered-industry-items .input-container .css-1fdsijx-ValueContainer {\n    width: 220px;\n  }\n\n  body .industry-container .btn-save-industry button {\n    width: 300px;\n  }\n\n\n}\n.button-wrapper {\n  margin-top: 10px;\n  margin-left: 10px;\n  position: absolute;\n  top: 8px;\n  left: 24px;\n}\n\n.back-button {\n  font-size: 16px;\n  padding: 4px 8px;\n  border: 1px solid black;\n  background-color: white;\n  border-radius: 4px;\n}\n\n.custom-hover:hover {\n  background-color: #0d6efd !important; /* override Bootstrap's bg-dark */\n  color: white !important; /* ensure text stays visible */\n  border-color: #0d6efd !important;\n  transition: background-color 0.2s ease;\n}\n\n/* Mobile devices (landscape) */\n@media only screen and (min-width: 481px) and (max-width: 768px) {}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
